<template>
  <div id="app">
    <van-overlay :show="$store.state.showShareTip" z-index="999999">
      <div class="_weixin_share_tip" @click="$showShareLay(false)"></div>
    </van-overlay>
    <!-- </div> -->

    <van-overlay :show="$store.state.showSubWx" z-index="50000">
      <div class="wrapperwewew">
        <div :style="'width:' + (isPc ? '30%' : '100%')">
          <subWx v-if="$store.state.showSubWx"></subWx>
        </div>
      </div>
    </van-overlay>

    <!-- 骨架 -->
    <div v-if="$store.state.showSkeleton" style="
        height: 100vh;
        background: #ffffff;
        padding-top: 15px;
        overflow: hidden;
      ">
      <div style="
          width: 100%;
          padding-left: 16px;
          padding-right: 16px;
          padding-bottom: 0px;
        ">
        <div style="
            width: 100%;
            height: 120px;
            background: #f2f3f5;
            line-height: 120px;
            text-align: center;
            color: rgba(120, 120, 120, 0.3);
            font-size: 15px;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            justify-items: center;
            align-content: center;
            align-items: center;
          "
        >
          考宝学涯
          <i class="el-icon-loading" style="margin-left: 3px"></i>
        </div>
      </div>

      <div v-for="index in 7" :key="index" style="margin-top: 15px">
        <van-skeleton avatar avatar-shape="square" avatar-size="90px" :row="3" :loading="true"></van-skeleton>
      </div>
    </div>

    <div class="BindAlertwrapper" v-show="isExtShow">
      <transition name="slide">
        <div style="width: 100%" v-if="isExtShow">
          <van-nav-bar left-arrow @click-left="closebinddialog" title="用户信息"></van-nav-bar>
          <BindAlert></BindAlert>
        </div>
      </transition>
    </div>

    <div v-show="!$store.state.showBind">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" v-show="!$store.state.showSkeleton" />
      </keep-alive>
      <router-view v-on:alert="alertP" v-on:shareTipC="shareTipP" v-on:setTitle="setTitle"
        v-if="!$route.meta.keepAlive" />
      <div id="bottomNav" v-if="bottomNavShow">
        <van-tabbar :border="false" route safe-area-inset-bottom active-color="#83a78d">
          <!-- left:0px;bottom:0px -->
          <!-- <a href="https://card.gaozhaotong.cn/#/PublicService" style="
              border-top: 2px solid #eeeeee;
              padding-top: 5px;
              padding-bottom: 5px;
              z-index: 100000;
              display: flex;
              flex-direction: column;
              width: 20%;
              justify-content: center;
              align-items: center;
            ">
            <img src="http://www.shouboke.tv/gaokaobao/img/icon/gxsj.png" style="width: 20px" />
            <span style="
                margin-top: 5px;
                color: #646566;
                font-size: 12px;
                line-height: 1;
                cursor: pointer;
              ">高校数据</span>
          </a> -->
          <van-tabbar-item v-for="(item, index) in navAry" replace :to="item.link" :key="index"
            style="border-top: 2px solid #eeeeee" @change="changeTab">
            <template>
              <span v-if="index !== 200" :class="{ hide: item.isHide }">{{
                item.title
              }}</span>
            </template>
            <template #icon="props">
              <img :class="{ hide: item.isHide }" v-if="index !== 200" :src="props.active ? item.activeSrc : item.src" />
            </template>
          </van-tabbar-item>
        </van-tabbar>
      </div>
      <div id="alertDiv" v-if="msgShow">{{ alertMsg }}</div>
      <div id="shareTip" @click="closeSharetTip" :class="{ sharein: shareShowAnimation }" v-if="shareShow">
        <img src="http://www.shouboke.tv/gaokao/img/img_reminder2x.png" alt />
      </div>
    </div>
    <!-- 全局 audio -->
    <audio :src="backMusic" autoplay loop v-if="isAudio" />

    <!-- 订阅 -->
    <subscribeMask :isShow.sync="isShow" v-if="isSubShow"></subscribeMask>
    <!-- <div class="bottom-box"> 栲宝科技（成都）有限公司版权所有©
      <a href="https://beian.miit.gov.cn">蜀ICP备2020032951号-2</a>
    </div> -->
  </div>
</template>

<script>
import BindAlert from "@/components/ownBindAlert";
import subWx from "@/components/subWx";
import agreement from "@/components/agreementNew";
// 订阅
import subscribeMask from "@/components/subscribe-mask";
export default {
  name: "App",
  data() {
    return {
      isShow: false,
      retryCount: 0,
      isPc: lycamWeb.IsPC(),
      bottomNavShow: true,
      alertMsg: "您的反馈已提交，我们将尽快给你答复！",
      msgShow: false,
      shareShow: false,
      shareShowAnimation: false,
      intervalMsg: null,
      backMusic: this.getRadomMusic(),
      isAudio: false,
      navAry: [
        // {
        //   title: "高校数据",
        //   active: false,
        //   isHide: false,
        //   src: "/static/icon/gxsj.png",
        //   activeSrc: "http://www.shouboke.tv/gaokaobao/img/icon/zc-p.png",
        //   link: "/gxsj"
        // },

        {
          title: "招生指南",
          active: false,
          isHide: false,
          src: "http://www.shouboke.tv/gaokaobao/img/icon/zx-n.png",
          activeSrc: "http://www.shouboke.tv/gaokaobao/img/icon/zx-p.png",
          link: "/ebook",
        },
        {
          title: "宣讲",
          active: true,
          isHide: false,
          src: "http://www.shouboke.tv/gaokaobao/img/icon/video1-n.png",
          activeSrc: "http://www.shouboke.tv/gaokaobao/img/icon/video1-p.png",
          link: "/video",
        },

        {
          title: "院校",
          active: true,
          isHide: false,
          src: "http://www.shouboke.tv/gaokaobao/img/icon/v-n.png",
          activeSrc: "http://www.shouboke.tv/gaokaobao/img/icon/v-p.png",
          link: "/orgList",
        },

        {
          title: "我的",
          active: false,
          isHide: false,
          src: "http://www.shouboke.tv/gaokaobao/img/icon/my-n.png",
          activeSrc: "http://www.shouboke.tv/gaokaobao/img/icon/my-p.png",
          link: "/my",
        },
      ],
    };
  },
  components: { BindAlert, subWx, agreement, subscribeMask },
  created: function () {
    //获取当前页面url
    // const url = window.location.href;
    // console.log("this.url", url);
    // if (url.indexOf("localhost") > -1) {
    //   return;
    // }else{
    //   // 更换域名 刷新页面
    //   if (url.indexOf("www.gaozhaotong.cn") > -1) {
    //     window.location.href = url.replace("www.gaozhaotong.cn", "kbxy.lycam.cn");
    //   }else if (url.indexOf("kbxy.gaokaobao.tv") > -1) {
    //     window.location.href = url.replace("kbxy.gaokaobao.tv", "kbxy.lycam.cn");
    //   }
    // }
   },
  mounted: function () {
    console.log("zjl", this.Token);
    console.log(
      222,
      window.location.href,
      window.location.href.includes("subscribe")
    );
    if (!window.location.href.includes("subscribe")) {
      this.getSubscribe();
    }
    const ChatType = lycamWeb.getCookie("ChatType");
    if (ChatType) {
      this.$setChatType(ChatType);
    }
    if (this.Token) {
      this.handleConnectSocket(this.Token);
    }
    if (window.location.href.indexOf("localhost") > -1) {
      this.handleConnectSocket(this.$store.state.myToken);
    }
  },
  beforeDestroy: function () {
    clearInterval(this.intervalMsg);
    this.beforeunloadFn();
    this.intervalMsg = null;
  },
  destroyed() { },
  provide() {
    return {
      handleConnectSocket: this.handleConnectSocket,
    };
  },
  methods: {
    getSubscribe() {
      let that = this;
      this.axios.get("/api/user/subscribe/get").then(function (res) {
        console.log("res", res);
        if (res.data.code == 0 && res.data.data.Id != 0) {
          that.isShow = false;
        } else {
          console.log(123);
          that.isShow = true;
        }
      });
    },
    beforeunloadFn(e) {
      console.log("用户下线");
      // 用户下线
      this.axios.post("/api/user/offline").then((res) => {
        if (res.data.code == 0) {
          console.log("用户退出宣讲");
        }
      });
    },
    closebinddialog() {
      this.$closeBind();
      var a = this.$currentQuery();
      a.qd = false;
      delete a.qd;
      this.$changeCurrentParams(a);
      {
        this.$goHome();
      }
    },
    changeTab(e) {
      console.log(e);
    },
    shareTipP: function () {
      this.shareShow = true;
      this.shareShowAnimation = true;
    },
    closeSharetTip: function () {
      this.shareShow = false;
    },
    setTitle: function (t) {
      window.document.querySelector("title").innerHTML = t;
    },
    alertP: function (msg, time) {
      this.alertMsg = msg;
      this.msgShow = true;
      setTimeout(() => {
        this.msgShow = false;
      }, time || 2000);
    },
    getRadomMusic() {
      var min = 0;
      var max = 4;
      var rand = Math.floor(Math.random() * (max - min + 1)) + min;
      console.log(rand);
      if (rand == 0) {
        return "https://www.shouboke.tv/gaokaobao/cdn/mp3/bgmusic.mp3";
      } else {
        return (
          "https://www.shouboke.tv/gaokaobao/cdn/mp3/bgmusic" + rand + ".mp3"
        );
      }
    },

    handleConnectSocket(val) {
      console.log("handleConnectSocket", val);
      // 连接socket
      let token = val;
      if (window.location.href.indexOf("localhost") > -1) {
        token = this.$store.state.myToken;
      }
      console.log(111, this.websocket.isConnect, token);
      if (!this.websocket.isConnect && token) {
        this.websocket.handleConnect(token, 3).then((response) => {
          console.log(response);
        });
      }
    },
  },

  computed: {
    Token() {
      return this.$store.state.userInfo.Token;
    },
    isExtShow() {
      return (
        this.$store.state.RegisterPhone !== 2 && this.$store.state.showBind
      );
    },
    isSubShow() {
      console.log("this.$store.state.RegisterPhone", this.$store.state.RegisterPhone);
      return this.$store.state.RegisterPhone == 2;
    },
  },
  watch: {
    $route: function (to, from) {
      console.log(this.$route.name);
      if (this.$route.name == "subscribe") {
        // this.getSubscribe();
        this.isShow = false;
      }
      console.log(111, to.name);
      this.bottomNavShow = false;
      this.navAry.forEach((i) => {
        // console.log(i.link)
        i.active = false;
        if (to.path == i.link) {
          i.active = true;
          this.bottomNavShow = true;
        }
      });
      this.setTitle(to.meta.title, to.name);
      if (lycamWeb.needConfig(to.name)) {
        this.$configWx();
      }
    },
    Token(val) {
      if (val) {
        this.handleConnectSocket(val);
      }
    },
  },
};
</script>

<style>
body {
  background-color: white;
  -webkit-overflow-scrolling: touch;
}

.van-tabbar--fixed {
  /* bottom: 20px; */
}

.bottom-box {
  /* position: fixed; */
  /* bottom: 0px;
  left: 0; */
  /* background-color: #fff; */
  text-align: center;
  width: 100vw;
  z-index: 3;
  padding-bottom: 10px;
  /* border-top: 1px dashed #646566; */
  /* height: 20px; */
  line-height: 20px;
}

#app {
  font-family: PingFangSC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  -webkit-overflow-scrolling: touch;
}

#bottomNav {
  z-index: 3;
  position: fixed;
  width: 100%;
  bottom: 0;
}

#bottomNav .van-tabbar {
  z-index: 3;
}

#bottomNav .yd-tabbar-icon img {
  height: 25px;
  width: 25px;
}

.navActive .yd-tabbar-txt {
  /* color: #6687ff; */
  color: #83a78d;
}

.el-image-viewer__btn {
  display: none;
}

.yd-tabbar .yd-tabbar-item .yd-tabbar-txt {
  font-size: 12px;
}

#alertDiv {
  white-space: nowrap;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 10px 46px;
  border-radius: 10px;
  opacity: 0.7;
  background-color: #000000;
  font-size: 17px;
  font-family: PingFangSC-Regular;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  z-index: 9999;
  text-align: left;
}

.emptyDate {
  text-align: center;
  margin: 25vh 0;
}

.emptyDate img {
  margin-bottom: 5px;
  width: 50px;
}

#shareTip {
  background-color: rgba(0, 0, 0, 0.65);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 8;
  text-align: center;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s;
  opacity: 0;
}

#shareTip.sharein {
  opacity: 1;
}

#shareTip img {
  /*width: 95%;*/
  height: 95%;
}

#app p,
#app div {
  word-break: break-all;
}

.pendingClass {
  color: #6687ff;
  border: #6687ff 1px solid;
  border-radius: 4px;
  padding: 0 5px;
  font-size: 12px;
  margin-right: 5px;
  line-height: 17px;
  vertical-align: middle;
  display: inline-block;
  /*color: red;*/
}

/*自定义模态框*/
.mydialog {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  font-family: PingFangSC-Regular;
  background-color: rgba(0, 0, 0, 0.4);
}

.mydialog>.content {
  margin: 0 auto;
  margin: 60% 12%;
  border-radius: 8px;
  background: white;
  min-height: 200px;
  padding: 10% 10%;
  text-align: center;
  font-size: 15px;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 21px;
}

.mydialog>.content>p {
  font-size: 20px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 28px;
  margin-bottom: 10px;
}

.mydialog>.content>span {
  font-size: 15px;
  font-weight: 400;
  color: rgba(116, 116, 116, 1);
  line-height: 21px;
}

#sureKnow {
  width: 100%;
  margin-top: 25px;
  /*border: 1px solid red;*/
}

#sureKnow>.yd-btn-block {
  width: 40%;
  float: left;
  margin: 0 auto;
  height: 40px;
  margin-top: 0;
  border-radius: 40px;
  margin-left: 15px;
  background: rgba(102, 135, 255, 1);
}

.hideIcon {
  width: 40px;
}

.smallIcon {
  width: 22px;
}

.slide-enter-active {
  animation-name: slideInUp;
  animation-duration: 0.8s;
  animation-fill-mode: both;
}

.slide-leave-active {
  animation-name: slideOutDown;
  animation-duration: 0.8s;
  animation-fill-mode: both;
}

@keyframes slideInUp {
  0% {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    transform: translateZ(0);
  }
}

@keyframes slideOutDown {
  0% {
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}

.delay-leave-active {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  -o-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.wrapperwewew {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

._weixin_share_tip {
  width: 92%;
  height: 96%;
  margin: 2% 4%;
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGlkPSLlm77lsYJfMSIgdmlld0JveD0iMCAwIDI4OC42IDE4NS4xIiBzdHlsZT0iYmFja2dyb3VuZDojMTExIj48c3R5bGU+LnN0M3tmaWxsOm5vbmU7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjI7c3Ryb2tlLW1pdGVybGltaXQ6MTB9LnN0NXtmaWxsOiNmZmZ9LnN0Nntmb250LWZhbWlseTomcXVvdDtNaWNyb3NvZnRZYUhlaSZxdW90O30uc3Q3e2ZvbnQtc2l6ZToxNnB4fTwvc3R5bGU+PGVsbGlwc2UgY3g9IjEzNi4xIiBjeT0iOTQuNyIgcng9IjEwNS44IiByeT0iNzEuNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWRhc2hhcnJheT0iNi4wMzEzLDYuMDMxMyIgaWQ9IlhNTElEXzFfIi8+PHBhdGggY2xhc3M9InN0MyIgZD0iTTIzMC41IDU3LjVzMi0uNyAzLjgtMS40Ii8+PHBhdGggZD0iTTIzOS45IDUzLjZjNS0yLjYgMTEuMi02LjkgMTQuNS0xMy4yIDYuNS0xMi4yLjItMjEuOS0xMC4zLTIwLjFzLTE3LjUgMTYuNC0uNiAyNWMxMy4xIDYuNiAyOS4zLTEyLjkgMzUuOS0yNC4xIiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtZGFzaGFycmF5PSI2LjIwODEsNi4yMDgxIi8+PHBhdGggY2xhc3M9InN0MyIgZD0iTTI2OS4zIDIwbDEzLjktOCAyIDE0LjgiLz48cGF0aCBjbGFzcz0ic3Q1IiBkPSJNMTc4LjcgMTM5LjNIOTYuM2MtMi4xIDAtMy44LTEuNi0zLjgtMy42di0yMi45YzAtMiAxLjctMy42IDMuOC0zLjZoODIuNGMyLjEgMCAzLjggMS42IDMuOCAzLjZ2MjIuOWMwIDItMS43IDMuNi0zLjggMy42eiIvPjx0ZXh0IHRyYW5zZm9ybT0idHJhbnNsYXRlKDcyLjgyIDcwLjM1NSkiIGNsYXNzPSJzdDUgc3Q2IHN0NyI+54K55Ye75Y+z5LiK6KeS5YiG5Lqr57uZPC90ZXh0Pjx0ZXh0IHRyYW5zZm9ybT0idHJhbnNsYXRlKDM5LjIyIDkzLjYpIiBjbGFzcz0ic3Q1IHN0NiBzdDciPuW+ruS/oeWlveWPi+aIluiAheWIhuS6q+WIsOaci+WPi+WciDwvdGV4dD48dGV4dCB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTYuMjA0IDEyOS40MjgpIiBmb250LXNpemU9IjE0IiBmb250LWZhbWlseT0iTWljcm9zb2Z0WWFIZWktQm9sZCI+55+l6YGT5LqGPC90ZXh0Pjwvc3ZnPg==) center top no-repeat;
}

.hide {
  opacity: 0;
}

@keyframes bigbig {
  0% {
    transform: scale(0.9);
  }

  50% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue